<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<p class="mgb_5">
					<span class="int_type mgr_5">
						<select id="dlActive" v-model="active_yn" @change="gotoPage(1)">
							<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }} </option>
							<option value="AB">Active & Blocked</option>
						</select>
					</span>

					<span v-show="!this.initial_partner_type" class="int_type mgr_10">
						<select v-model="partner_type" @change="gotoPage(1)" :disabled="user.customer_only_view">
							<option value="A">All Type</option>
							<option value="C">Customer</option>
							<option value="V">Vendor</option>
							<option value="B">Both</option>
						</select>
					</span>

					<em class="lt_text">Reg.Date</em>
					<span class="mgr_5">
						<CustomDatePicker v-model="crt_date_from" /> ~
						<CustomDatePicker v-model="crt_date_to" />
					</span>

					<em class="lt_text">Grade</em>
					<span class="int_type_no_border mgr_5">
						<CodeSelect :width="60" :showDesc="false" :codes="grades" v-model="grade" />
					</span>

					<!--					<em class="lt_text">Country</em>-->
					<!--					<span class="int_type_no_border mgr_5">-->
					<!--						<CodeSelect :width="60" :showDesc="false" :codes="countries" v-model="country" @post-loading="postCoutryLoading" />-->
					<!--					</span>-->

					<country-select :countries="countries" :bool="true" v-model="country" />

					<em class="lt_text">State</em>
					<span class="int_type_no_border mgr_5">
						<CodeSelect :width="60" :codeWidth="120" :showDesc="false" :codes="filteredStates" v-model="state" />
					</span>

					<template v-if="user.company_id == 'newjigu'">
						<em class="lt_text">Territory</em>
						<span class="int_type_no_border mgr_5">
							<CodeSelect :width="60" :codeWidth="120" :showDesc="false" :codes="territories" v-model="territory_code" />
						</span>
					</template>

					<span v-show="!this.initial_partner_type || this.initial_partner_type == 'C'">
						<em class="lt_text">Sales Group</em>
						<span class="int_type_no_border mgr_5">
							<CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="false" v-model="sales_group_code" @set-code="setSalesGroup" />
						</span>
					</span>

					<span v-show="!this.initial_partner_type || this.initial_partner_type == 'C'">
						<em class="lt_text">Salesman</em>
						<span class="int_type_no_border mgr_5">
							<CodeSelect className="tbl_select" :codes="salesmansForSearch" :showDesc="false" v-model="salesman_id" @set-code="setSalesman" />
						</span>
					</span>

					<span class="int_type mgr_5" style="width: 120px;">
						<input type="text" v-model="keyword" placeholder="Enter Keyword" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<span v-show="!this.initial_partner_type || this.initial_partner_type == 'C'" class="int_type mgr_15" style="width: 120px;">
						<input type="text" v-model="track_no" placeholder="UPS Tracking No" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<span class="int_type ssm_int">
						<input type="text" class="ssm_int" v-model.trim="from_zip_code" title="From Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>
					~
					<span class="int_type ssm_int mgr_5">
						<input type="text" class="ssm_int" v-model.trim="to_zip_code" title="To Zip Code" placeholder="Zip Code" autofocus autocomplete="off" @keyup.enter="gotoPage(1)" />
					</span>

					<a href="javascript:void(0);" class="search_bt" @click="gotoPage(1)">Search</a>
					<a href="javascript:void(0);" class="gray_bt mgr_10" @click="reset()">Reset</a>
					<!-- #3406 : Restriction 조회자에게만 보인다. 체크하면 지정 State 자료를 조회 전용으로 본다. -->
					<label v-if="restriction_only_showable" for="restriction_only" class="mgr_10"> <input type="checkbox" id="restriction_only" v-model="restriction_only" @change="changeRestrictionOnly()" /> Restriction Only</label>

					<input v-if="env === 'development'" type="checkbox" v-model="include_balance" />
				</p>
			</div>
		</div>

		<partnerTable :company_id="company_id" :partners="partners" @sort="sort" :sort_key="sort_key" :sort_direction="sort_direction" :restriction_only="state_scope_read_only" @memo="memo" @arHistory="gotoArHistory" />

		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>
		<div class="fl_r int_type mgr_15">
			<select v-model="page_size" @change="search">
				<option value="25">25 per page</option>
				<option value="50">50 per page</option>
				<option value="100">100 per page</option>
				<option value="200">200 per page</option>
			</select>
		</div>

		<div class="bottom_bt_box">
			<ul class="fl_l mgr_15">
				<li v-if="(user.company_id != 'newjigu' || modifiable) && !state_scope_read_only"><a href="javascript:void(0)" @click="customersWithNoRecentSalesShow">Customers With No Recent Sales</a></li>
			</ul>
			<ul>
				<li v-if="!state_scope_read_only"><a href="javascript:void(0)" @click="confirmCustomerStatement('bill_to_code')">Bill To Customer Statement</a></li>
			</ul>
			<ul>
				<li v-if="!state_scope_read_only"><a href="javascript:void(0)" @click="confirmCustomerStatement('ship_to_code')">Ship To Customer Statement</a></li>
			</ul>
			<ul>
				<li v-if="modifiable">
					<router-link :to="{ name: 'partnerDetail', params: { mode: 'add', initial_partner_type: this.initial_partner_type }, query: { backUri: this.uri } }">Add </router-link>
				</li>
			</ul>
			<ul>
				<li v-if="(user.company_id != 'newjigu' || modifiable) && !state_scope_read_only"><a href="javascript:void(0)" @click="reportPrint">Print</a></li>
			</ul>
			<ul>
				<li v-if="user.company_id == 'jc' && !state_scope_read_only"><a href="javascript:void(0)" @click="excelSBM()">SBM Excel</a></li>
			</ul>
			<ul>
				<li v-if="(user.company_id != 'newjigu' || modifiable) && !state_scope_read_only"><a href="javascript:void(0)" @click="reportExcel">Excel</a></li>
			</ul>

			<div v-if="['newjigu'].includes(company_id) && !state_scope_read_only" style="clear: both; padding-top: 5px;">
				<label class="right_option mgr_15"><input type="checkbox" v-model="show_credit" /> Show All Credit in Printed Customer Statement.</label>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul class="fl_l mgr_15" v-if="modifiable">
				<li class="mgr_5" style="padding-top:3px;">
					<label for="apply_to_old_invoices" style="margin-left:5px;margin-right:10px;"> <input type="checkbox" id="apply_to_old_invoices" v-model="apply_to_old_invoices" />Apply To Old Invoices</label>
					<label for="apply_to_old_store_credits" style="margin-left:5px;margin-right:10px;"> <input type="checkbox" id="apply_to_old_store_credits" v-model="apply_to_old_store_credits" />Apply To Old Store Credits</label>
					<label for="apply_to_old_call_tags" style="margin-left:5px;margin-right:10px;"> <input type="checkbox" id="apply_to_old_call_tags" v-model="apply_to_old_call_tags" />Apply To Old Call Tags</label>
				</li>
				<li>
					<span class="int_type_no_border mgr_5">
						<CodeSelect className="tbl_select" :codes="salesGroups" :showDesc="true" v-model="change_to_sales_group_code" />
					</span>
				</li>
				<li><a href="javascript:;" @click="changeSalesGroup()">Change Sales Group</a></li>
			</ul>

			<ul class="fl_l mgr_15" v-if="modifiable">
				<li>
					<span class="int_type_no_border mgr_5">
						<CodeSelect className="tbl_select" :codes="salesmansForChange" :showDesc="true" v-model="change_to_salesman_id" />
					</span>
				</li>
				<li><a href="javascript:;" @click="changeSalesman()">Change Salesman</a></li>
			</ul>

			<ul class="fl_l mgr_15" v-if="modifiable">
				<li><a href="javascript:;" @click="changeSalesGroupAndSalesman()">Change Sales Group & Salesman Both</a></li>
			</ul>

			<div class="batch_partners_row mgr_15" style="clear: both; padding-top: 8px;" v-if="modifiable && company_id === 'beautyplus'">
				<select-partners ref="batchPartners" v-model="change_partner_string" ac-width="260px" code-width="100%" />
			</div>

			<div class="fl_l mgr_15" v-if="company_id === 'he' && partner_type !== 'V' && modifiable">
				<PartnerSelect v-model="reps_bill_to_code" class="mgr_5" :activeOnly="true" :nameWidth="200" ph="New Bill To" />
				<a href="javascript:;" class="gray_bt" @click="changeBillTo()">Change Bill To</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="selected_partner_code" :read_only="state_scope_read_only" v-on:close="closeModal($event)" />
			</template>
		</Modal>

		<CustomerStatementCriteria
			v-if="showModal && modalName == 'customer_statement_criteria'"
			@close="closeModal()"
			:show_credit="show_credit"
			:show_PDC="show_PDC"
			:show_payment="show_payment"
			:init_payment_date="payment_date"
			@change_show_credit="boolean => (show_credit = boolean)"
			@change_show_PDC="boolean => (show_PDC = boolean)"
			@change_show_payment="boolean => (show_payment = boolean)"
			@change_payment_date="date => (payment_date = date)"
			@printStatement="customerStatement()"
		/>

		<customers-without-invoices />
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { isStateScopeBlocked } from '@/api/index';
import { apiIndex, apiSelectPartnerList, apiUpdatePartnerSalesGroupBatch, apiUpdatePartnerSalesmanBatch, apiUpdatePartnerSalesgroupAndSalesmanBatch, apiUpdateBillToOfPartners } from '@/api/partner/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import Paging from '@/components/common/Paging';
import CodeSelect from '@/components/common/CodeSelect';
import Modal from '@/components/common/Modal';
import MemoPopup from '@/components/common/MemoPopup';
import CustomerStatementCriteria from '@/components/common/CustomerStatementCriteria.vue';
import { apiGetBase64ReportTemplate, companyMrtUrl, exportDataExcel, objectCopy, objectToFormData, PrintType, Report, reportMrtUrl, reportRender } from '@/api/util';
import { today } from '@/utils/date';
import { apiSelectCustomerStatement } from '@/api/report/report';
import { defaultDataType } from 'export-xlsx';
// import { reorganizeInvAndPay, combineInvAndPDC } from '@/utils/customerStatement.js';
import CustomersWithoutInvoices from '@/views/partner/CustomersWithNoRecentSales';
import PartnerTable from '@/views/partner/PartnerTable';
import CountrySelect from '@/components/common/CountrySelect';
import PartnerSelect from '@/components/common/PartnerSelect.vue';
import SelectPartners from '@/components/common/SelectPartners';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			active_yn: 'A',
			partner_type: 'A',
			keyword: null,

			initial_partner_type: null,

			sort_key: 'code',
			sort_direction: 'ASC',

			crt_date_from: null,
			crt_date_to: null,
			track_no: null,

			partners: [],

			grade: '',
			grades: [],
			state: '',
			states: [],
			territory_code: null,
			territories: [],
			country: '',
			countries: [],
			salesGroups: [],
			sales_group_code: null,
			sales_team_code_by_group: null,
			sales_team_code_by_man: null,
			saveParam: {},
			modalName: '',
			showModal: false,
			selected_partner_code: null,
			salesmans: [],
			salesmans_for_change: [],
			salesman_id: null,
			to_zip_code: null,
			from_zip_code: null,

			allSelected: false,
			change_to_sales_group_code: null,
			change_to_salesman_id: null,
			change_partner_string: '',
			reps_bill_to_code: null,

			apply_to_old_invoices: false,
			apply_to_old_store_credits: false,
			apply_to_old_call_tags: false,

			include_balance: process.env.NODE_ENV == 'development' ? false : true,

			show_credit: true,
			show_PDC: true,
			show_payment: false,
			customer_statement_type: null,
			payment_date: today(),

			// #3406 : Restriction Only 보기. 체크 상태(restriction_only)는 selectParam 밖에 두어 해제면 요청이 종전과 같다.
			// 조회자 표식(restriction_only_available)은 index 가, 조회 전용 표식(state_scope_read_only)은 목록 응답이 준다.
			restriction_only: false,
			restriction_only_available: false,
			state_scope_read_only: false,
			// #3406 : 목록 요청 순번. 늦게 온 이전 요청의 응답은 버린다.
			partner_list_seq: 0,
		};
	},
	computed: {
		filteredStates: function() {
			if (!this.country && this.user.company_id == 'newjigu') return this.states;

			//return this.states;
			var vm = this;
			var fStates = this.states.filter(s => s.country == vm.country);
			//console.log(fStates.length);
			if (fStates.length == 0) vm.state = null;
			//else vm.state = fStates[0].state;

			return fStates;
			//console.log(this.states.filter(s => s.country == vm.country));
			//return this.states.filter(s => s.country == vm.country);
		},
		modifiable() {
			// #3406 : 지정 State 자료(Restriction Only 보기 응답)는 조회 전용이다(Add·일괄 변경 없음).
			if (this.state_scope_read_only) return false;
			var menus = this.$session.get('menus');
			//console.log(this.$router.history.current.path);
			var current_path = this.$router.history.current.path;
			if (this.initial_partner_type == 'C') current_path = current_path.replace('partner_main', 'customer_main');
			else if (this.initial_partner_type == 'V') current_path = current_path.replace('partner_main', 'vendor_main');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == current_path || menus[i].path == current_path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},

		checkedPartner() {
			return this.partners.filter(partner => partner.selected).map(partner => partner.code);
		},
		salesmansForSearch() {
			return this.salesmans.filter(sm => !this.sales_team_code_by_group || sm.sales_team_code === this.sales_team_code_by_group).map(sm => ({ code: sm.user_id, name: sm.name, sales_team_code: sm.sales_team_code }));
		},
		salesmansForChange() {
			return this.salesmans_for_change.filter(sm => !this.change_to_sales_group_code || sm.sales_group_code === this.change_to_sales_group_code).map(sm => ({ code: sm.user_id, name: sm.user_name, sales_team_code: sm.sales_team_code }));
			//return this.salesmans.map(sm => ({ code: sm.user_id, name: sm.name }));
		},
		env: function() {
			return process.env.NODE_ENV;
		},
		companyIsNewjigu() {
			return this.company_id === 'newjigu';
		},
		// #3406 : Restriction Only 체크박스는 조회자에게, Partner·Customer 목록에서만 보인다(Vendor 제외).
		restriction_only_showable() {
			return this.restriction_only_available && this.initial_partner_type !== 'V';
		},
		selectParam() {
			return {
				active_yn: this.active_yn,
				partner_type: this.partner_type,
				keyword: this.keyword,
				grade: this.grade,
				state: this.state,
				country: this.country,
				territory_code: this.territory_code,
				sales_team_code_by_group: this.sales_team_code_by_group,
				sales_team_code_by_man: this.sales_team_code_by_man,
				sales_group_code: this.sales_group_code,
				salesman_id: this.salesman_id,
				//all_sales_group: true,
				include_in_charge: true,
				from_main: true,
				crt_date_from: this.crt_date_from,
				crt_date_to: this.crt_date_to,
				track_no: this.track_no,
				paging_yn: this.paging_yn,
				page_size: Number(this.page_size),
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				initial_partner_type: this.initial_partner_type,
				from_zip_code: this.from_zip_code,
				to_zip_code: this.to_zip_code,
				//include_balance: this.include_balance,
			};
		},

		defaultCountry: {
			//parameter 에서 country 가 있으면 true 로 리턴
			get() {
				return this.$route.query.country !== undefined;
			},
			set() {},
		},
	},
	components: {
		CountrySelect,
		PartnerTable,
		CustomersWithoutInvoices,
		Paging,
		CodeSelect,
		Modal,
		MemoPopup,
		CustomDatePicker,
		CustomerStatementCriteria,
		PartnerSelect,
		SelectPartners,
	},
	methods: {
		getTargetPartners() {
			if (this.change_partner_string && this.change_partner_string.trim()) {
				return this.change_partner_string
					.split(/ |,/)
					.map(code => code.trim())
					.filter(Boolean)
					.map(code => ({ code }));
			}
			return this.partners.filter(p => p.selected);
		},
		resetBatchPartners() {
			if (this.$refs.batchPartners) this.$refs.batchPartners.reset();
		},
		async changeBillTo() {
			if (this.partners.filter(p => p.selected).length == 0) {
				this.$toast.error('No partner(s) selected.');
				return;
			}

			if (!this.reps_bill_to_code) {
				this.$toast.error('"Bill To" not selected.');
				return;
			}

			var msg = 'Are you sure to change "bill to" of the selected?';
			msg += '\r\n"Bill to" of old invoice(s) will be changed.';
			msg += '\r\nAnd Status of selected will be inactive.';

			if (!confirm(msg)) return;

			const partner_codes = this.partners.filter(p => p.selected).map(p => p.code);
			const { status } = await apiUpdateBillToOfPartners(this.reps_bill_to_code, partner_codes);

			if (status === 200) {
				this.selectPartners(
					this.page_no,
					this.partners.filter(p => p.selected),
				);
				this.$toast.success('Success To Change.');
			} else {
				this.$toast.error('Failure To Change.');
			}
		},
		async changeSalesGroup() {
			const target_partners = this.getTargetPartners();
			if (target_partners.length == 0) {
				this.$toast.error('No partner(s) selected.');
				return;
			}

			if (!this.change_to_sales_group_code) {
				this.$toast.error('Sales group not selected.');
				return;
			}

			var msg = 'Are you sure to change sales group of ' + target_partners.length + ' partner(s)?';
			if (this.apply_to_old_invoices || this.apply_to_old_store_credits || this.apply_to_old_call_tags) {
				msg += '\n\nSalesgroup of following data will be changed.\n';

				if (this.apply_to_old_invoices) msg += '\n - Invoice(s)';
				if (this.apply_to_old_store_credits) msg += '\n - Store Credit(s)';
				if (this.apply_to_old_call_tags) msg += '\n - Call Tag(s)';
			}

			if (confirm(msg)) {
				var param = { partners: target_partners, sales_group_code: this.change_to_sales_group_code };
				if (this.apply_to_old_invoices) param.apply_to_old_invoices = true;
				if (this.apply_to_old_store_credits) param.apply_to_old_store_credits = true;
				if (this.apply_to_old_call_tags) param.apply_to_old_call_tags = true;

				const { data } = await apiUpdatePartnerSalesGroupBatch(param);

				if (data.result) {
					this.$toast.success('Updated successfully');
					this.resetBatchPartners();
					this.selectPartners(
						this.page_no,
						this.partners.filter(p => p.selected),
					);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async changeSalesman() {
			const target_partners = this.getTargetPartners();
			if (target_partners.length == 0) {
				this.$toast.error('No partner(s) selected.');
				return;
			}

			if (!this.change_to_salesman_id) {
				this.$toast.error('Salesman not selected.');
				return;
			}

			if (confirm('Are you sure to change salesman of ' + target_partners.length + ' partner(s)?')) {
				const { data } = await apiUpdatePartnerSalesmanBatch({ partners: target_partners, sales_group_code: this.change_to_sales_group_code, salesman_id: this.change_to_salesman_id });

				if (data.result) {
					this.$toast.success('Updated successfully');
					this.resetBatchPartners();
					this.selectPartners(
						this.page_no,
						this.partners.filter(p => p.selected),
					);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		async changeSalesGroupAndSalesman() {
			const target_partners = this.getTargetPartners();
			if (target_partners.length == 0) {
				this.$toast.error('No partner(s) selected.');
				return;
			}

			if (!this.change_to_sales_group_code) {
				this.$toast.error('Sales group not selected.');
				return;
			}

			if (!this.change_to_salesman_id) {
				this.$toast.error('Salesman not selected.');
				return;
			}

			var msg = 'Are you sure to change sales group and salesman of ' + target_partners.length + ' partner(s)?';
			if (this.apply_to_old_invoices) msg += '\n\nSalesgroup of old invoice(s) will be changed.';

			if (confirm(msg)) {
				var param = { partners: target_partners, sales_group_code: this.change_to_sales_group_code, salesman_id: this.change_to_salesman_id };
				if (this.apply_to_old_invoices) param.apply_to_old_invoices = true;
				const { data } = await apiUpdatePartnerSalesgroupAndSalesmanBatch(param);

				if (data.result) {
					this.$toast.success('Updated successfully');
					this.resetBatchPartners();
					this.selectPartners(
						this.page_no,
						this.partners.filter(p => p.selected),
					);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		setSalesGroup(sg) {
			if (sg) {
				if (sg.sales_team_code !== this.sales_team_code_by_man) {
					this.salesman_id = null;
					this.sales_team_code_by_man = null;
				}

				this.sales_team_code_by_group = sg.sales_team_code;
			} else {
				this.sales_team_code_by_group = null;
			}
		},
		setSalesman(sm) {
			if (sm) this.sales_team_code_by_man = sm.sales_team_code;
			else this.sales_team_code_by_man = null;
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.partners.forEach(function(partner) {
				partner.selected = vm.allSelected;
			});
		},
		gotoArHistory(partner_code, partner_name) {
			const query = {
				backUri: this.uri,
				bill_to_code: partner_code,
				bill_to_name: partner_name,
				date_type_is_invoice: '1',
			};
			// #3406 : Restriction Only 보기의 잔액은 A/R History 도 같은 보기로 연다.
			if (this.state_scope_read_only) query.restriction_only = 'true';
			this.$router.push({
				name: 'arHistory',
				query: query,
			});
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(rv) {
			this.showModal = false;
			if (rv) this.selectPartners(this.page_no);
		},
		memo(partner) {
			this.selected_partner_code = partner.code;
			this.openModal('Memo');
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (sort_key == 'no') return;

			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				if (this.sort_key == 'ytd') this.sort_direction = 'DESC';
				else this.sort_direction = 'ASC';
			}
			this.search();
		},
		reset() {
			this.sort_key = 'code';
			this.sort_direction = 'ASC';

			this.keyword = null;
			this.grade = null;
			this.state = null;
			this.country = 'US';
			this.territory_code = null;
			//this.country = '';
			this.sales_team_code_by_group = null;
			this.sales_team_code_by_man = null;
			this.sales_group_code = null;
			this.salesman_id = null;

			this.crt_date_from = null;
			this.crt_date_to = null;
			this.track_no = null;
			this.from_zip_code = null;
			this.to_zip_code = null;

			this.show_credit = true;
			this.show_PDC = true;
			this.show_payment = false;
			this.customer_statement_type = null;
			this.payment_date = today();
			// #3406 : Reset 은 Restriction Only 체크도 푼다. 보이는 지정 State 자료의 잠금은 다음 조회까지 응답 표식으로 남는다.
			this.restriction_only = false;
		},
		// #3406 : 보기를 바꾸면 State 필터(보기마다 목록이 다르다)와 페이지를 초기화하고 다시 조회한다.
		changeRestrictionOnly() {
			this.state = null;
			this.gotoPage(1);
		},
		search() {
			let name;
			if (this.initial_partner_type === 'C') name = 'customers';
			else if (this.initial_partner_type === 'V') name = 'vendors';
			else name = 'partner';

			// #3406 : URL 에는 문자열 'true' 로 남긴다. 해제면 query 가 종전과 같다.
			const query = this.restriction_only ? Object.assign({}, this.selectParam, { restriction_only: 'true' }) : this.selectParam;
			this.$router.push({ name: name, query: query }).catch(() => {});
		},

		findCustomer(list, code) {
			if (list.filter(p => p.code == code).length > 0) return true;
			else return false;
		},
		async selectPartners(pageNo, retain_selected_list) {
			//console.log(pageNo, retain_selected_list);
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			let param = this.selectParam;

			if (this.user.company_id == 'newjigu') param.all_sales_group = true;
			if (this.include_balance) param.include_balance = this.include_balance;
			// #3406 : 늦게 온 이전 요청의 응답은 화면을 바꾸지 않는다.
			const seq = ++this.partner_list_seq;
			let data;
			if (this.restriction_only) {
				// #3406 : Restriction Only 체크일 때만 boolean 플래그를 싣는다. 요청 형태가 거부되면 안내 화면으로 가지 않고
				// 체크를 풀고 목록을 비운다(안내 토스트는 interceptor 가 띄운다).
				try {
					({ data } = await apiSelectPartnerList(Object.assign({}, param, { restriction_only: true }), { stateScopeOptional: true }));
				} catch (e) {
					if (!isStateScopeBlocked(e)) throw e;
					if (seq !== this.partner_list_seq) return;
					this.restriction_only = false;
					this.state_scope_read_only = false;
					this.partners = [];
					this.list_count = 0;
					this.$refs.paging.setPage(this.page_no, this.page_size, 0);
					return;
				}
			} else {
				({ data } = await apiSelectPartnerList(param));
			}
			if (seq !== this.partner_list_seq) return;
			// #3406 : 잠금은 이 응답의 표식으로 정한다. 표식이 없으면 푼다.
			this.state_scope_read_only = !!data.state_scope_read_only;

			//console.log('....' + this.country + '**');
			// if (this.country) this.$session.set('partner_country', this.country);
			// else this.$session.set('partner_country', '__blank');

			this.saveParam = {
				active_yn: this.active_yn,
				partner_type: this.partner_type,
				keyword: this.keyword,
				grade: this.grade,
				state: this.state,
				country: this.country,
				territory_code: this.territory_code,
				sales_group_code: this.sales_group_code,
				salesman_id: this.salesman_id,
				include_in_charge: true,
				from_main: true,
				crt_date_from: this.crt_date_from,
				crt_date_to: this.crt_date_to,
				track_no: this.track_no,
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				from_zip_code: this.from_zip_code,
				to_zip_code: this.to_zip_code,
			};

			var no = 0;
			data.partnerList.forEach(partner => {
				if (partner.ytd == null) partner.ytd = 0;

				partner.no = ++no + (this.page_no - 1) * this.page_size;
			});
			this.partners = data.partnerList;
			this.list_count = data.list_count;

			var vm = this;
			if (retain_selected_list) {
				this.partners.forEach(p => {
					if (vm.findCustomer(retain_selected_list, p.code)) p.selected = true;
				});
			}

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		gotoPage(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.search();
		},
		selectPartner(selectedPartner) {
			this.$router.push({
				name: 'partnerDetail',
				params: { mode: 'detail' },
				query: this.state_scope_read_only ? { backUri: this.uri, code: selectedPartner.code, restriction_only: 'true' } : { backUri: this.uri, code: selectedPartner.code },
			});
		},

		async index() {
			const { data } = await apiIndex();

			// #3406 : 조회자 표식. 이 값을 받은 뒤에만 URL 의 Restriction Only 를 복원한다.
			this.restriction_only_available = !!data.restriction_only_available;
			this.grades = data.gradeList;
			this.states = data.stateList;
			this.countries = data.countryList;
			this.salesGroups = data.salesGroupList;
			this.salesmans = data.salesmanList;
			this.salesmans_for_change = data.salesmanForChangeList;
			this.territories = data.territoryList;
		},
		// #3406 : Restriction Only 보기의 State 필터(지정 State 의 State 만)를 받는다.
		async loadRestrictionOnlyStates() {
			const { data } = await apiIndex({ restriction_only: 'true' });
			if (data.restrictionOnlyStateList) this.states = data.restrictionOnlyStateList;
		},
		async init() {
			await this.index();
			// #3406 : URL 의 restriction_only=true 는 조회자 표식을 받은 뒤에만 복원한다. 비조회자는 요청이 종전과 같다.
			if (this.$route.query.restriction_only === 'true' && this.restriction_only_showable) {
				this.restriction_only = true;
				await this.loadRestrictionOnlyStates();
			}
			this.active_yn = this.companyIsNewjigu ? 'Y' : 'A';
			if (this.user.customer_only_view) this.partner_type = 'C';
			let query = this.$route.query;
			if (query.country === undefined) {
				this.postCoutryLoading();
			} else {
				this.country = query.country;
			}
			if (query.page_size) this.page_size = query.page_size;
			if (query.sort_key) this.sort_key = query.sort_key;
			if (query.sort_direction) this.sort_direction = query.sort_direction;
			if (query.active_yn) this.active_yn = query.active_yn;
			if (query.partner_type) this.partner_type = query.partner_type;
			if (query.grade) this.grade = query.grade;
			if (query.state) this.state = query.state;
			if (query.territory_code) this.territory_code = query.territory_code;
			if (query.country) this.country = query.country;
			if (query.sales_team_code_by_group) this.sales_team_code_by_group = query.sales_team_code_by_group;
			if (query.sales_team_code_by_man) this.sales_team_code_by_man = query.sales_team_code_by_man;
			if (query.sales_group_code) this.sales_group_code = query.sales_group_code;
			if (query.salesman_id) this.salesman_id = query.salesman_id;
			if (query.crt_date_from) this.crt_date_from = query.crt_date_from;
			if (query.crt_date_to) this.crt_date_to = query.crt_date_to;
			if (query.track_no) this.track_no = query.track_no;
			if (query.keyword) this.keyword = query.keyword;
			if (query.from_zip_code) this.from_zip_code = query.from_zip_code;
			if (query.to_zip_code) this.to_zip_code = query.to_zip_code;
			if (query.include_balance) this.include_balance = query.include_balance;

			await this.selectPartners(query.page_no);
		},
		postCoutryLoading() {
			// 뉴지구도 디폴트는 전체
			if (['newjigu'].includes(this.company_id)) return;

			let idx = this.countries.findIndex(c => c.code === 'US');
			if (idx < 0) idx = this.countries.findIndex(c => c.code === 'USA');
			if (idx > -1) this.country = this.countries[idx].code;
		},

		async reportPrint() {
			const { data } = await apiSelectPartnerList(this.saveParam);
			await reportRender(data, 'partnerList', reportMrtUrl('partnerList'));
		},
		async excelSBM() {
			const { data } = await apiSelectPartnerList(this.saveParam);

			if (this.initial_partner_type === 'C') {
				let header = [
					{ key: 'code', name: 'Customer #', width: 13, dataType: defaultDataType.string },
					{ key: 'name', name: 'Customer Name', width: 25, dataType: defaultDataType.string },
					{ key: 'address_detail', name: 'Address 1', width: 45, dataType: defaultDataType.string },
					{ key: 'address_city', name: 'City', width: 15, dataType: defaultDataType.string },
					{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.string },
					{ key: 'address_zipcode', name: 'Zip', width: 10, dataType: defaultDataType.string },
					{ key: 'telephone', name: 'Tel', width: 15, dataType: defaultDataType.string },
					{ key: 'owner_name', name: 'Contact 1', width: 40, dataType: defaultDataType.string },
					{ key: 'sales_group_name', name: 'Sales Rep', width: 20, dataType: defaultDataType.string },
					{ key: 'payment_term_name', name: 'Terms', width: 15, dataType: defaultDataType.string },
					{ key: '', name: 'Custom1', width: 35, dataType: defaultDataType.string },
					{ key: '', name: 'Custom2', width: 35, dataType: defaultDataType.string },
					{ key: '', name: 'Custom3', width: 35, dataType: defaultDataType.string },
					{ key: 'email', name: 'Email', width: 30, dataType: defaultDataType.string },
				];

				exportDataExcel(data.partnerList, header, 'CustomerSBM');
			} else if (this.initial_partner_type === 'V') {
				let header = [
					{ key: 'code', name: 'Vendor #', width: 13, dataType: defaultDataType.string },
					{ key: 'name', name: 'Vendor Name', width: 25, dataType: defaultDataType.string },
					{ key: 'address_detail', name: 'Address 1', width: 35, dataType: defaultDataType.string },
					{ key: 'address_detail2', name: 'Address 2', width: 20, dataType: defaultDataType.string },
					{ key: 'address_city', name: 'City', width: 15, dataType: defaultDataType.string },
					{ key: 'address_state', name: 'State', width: 10, dataType: defaultDataType.string },
					{ key: 'address_zipcode', name: 'Zip', width: 10, dataType: defaultDataType.string },
					{ key: 'telephone', name: 'Tel', width: 15, dataType: defaultDataType.string },
					{ key: 'fax', name: 'Fax', width: 15, dataType: defaultDataType.string },
					{ key: 'email', name: 'Email', width: 30, dataType: defaultDataType.string },
					{ key: 'attention_name', name: 'Contact', width: 25, dataType: defaultDataType.string },
				];

				exportDataExcel(data.partnerList, header, 'VendorSBM');
			}
		},
		async reportExcel() {
			const param = objectCopy(this.saveParam);
			param.include_doc_cnt = true;
			const { data } = await apiSelectPartnerList(param);
			// await reportRender(data, 'partnerList', reportMrtUrl('partnerList'));

			let header = [
				{ key: 'code', name: 'Code', width: 15, dataType: defaultDataType.string },
				{ key: 'name', name: 'Name', width: 25, dataType: defaultDataType.string },
				{ key: 'ytd', name: 'YTD', width: 15, dataType: defaultDataType.currency },
				{ key: 'sales_group_name', name: 'Sales Group', width: 20, dataType: defaultDataType.string },
				{ key: 'sales_team_name', name: 'Sales Team', width: 20, dataType: defaultDataType.string },
				{ key: 'salesman_id', name: 'Salesman', width: 15, dataType: defaultDataType.string },
				{ key: 'last_invoice_date', name: 'Last Invoice Date', width: 15, dataType: defaultDataType.string },
				{ key: 'last_invoice_amount', name: 'Last Invoice Amount', width: 15, dataType: defaultDataType.currency },
				{ key: 'telephone', name: 'Phone 1', width: 15, dataType: defaultDataType.string },
				{ key: 'telephone2', name: 'Phone 2', width: 15, dataType: defaultDataType.string },
				{ key: 'address_detail', name: 'Address', width: 45, dataType: defaultDataType.string },
				{ key: 'address_city', name: 'City', width: 15, dataType: defaultDataType.string },
				{ key: 'address_state', name: 'state', width: 15, dataType: defaultDataType.string },
				{ key: 'address_zipcode', name: 'Zip Code', width: 15, dataType: defaultDataType.string },
				{ key: 'country', name: 'Country', width: 15, dataType: defaultDataType.string },
				{ key: 'open_date', name: 'Open Date', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'Payment', width: 15, dataType: defaultDataType.string },
				{ key: 'delivery_type_name', name: 'Delivery type', width: 15, dataType: defaultDataType.string },
				{ key: 'email', name: 'Email', width: 35, dataType: defaultDataType.string },
				{ key: 'active_yn', name: 'Active', width: 10, dataType: defaultDataType.string },
				{ key: 'blocked', name: 'Blocked', width: 10, dataType: defaultDataType.string },
				{ key: 'block_reason', name: 'Block Reason', width: 40, dataType: defaultDataType.string },
				{ key: 'owner_name', name: 'Owner Name', width: 40, dataType: defaultDataType.string },
				{ key: 'doc_cnt', name: 'Count of Document', width: 20, dataType: defaultDataType.currency },
			];

			exportDataExcel(data.partnerList, header, 'Partners');
		},

		async confirmCustomerStatement(type) {
			if (!this.checkedPartner || !this.checkedPartner.length) {
				this.$toast.error('Please Select Customer First.');
				return;
			}

			this.customer_statement_type = type;
			this.customerStatement();
		},
		async customerStatement() {
			const param = objectToFormData({
				partner_codes: this.checkedPartner,
				comparison_target: this.customer_statement_type,
				date: today(),
				payment_date: this.payment_date,
				show_credit: this.show_credit,
				show_PDC: this.show_PDC,
				show_payment: this.show_payment,
			});
			const { data } = await apiSelectCustomerStatement(param);

			// reorganizeInvAndPay(data.data, this.company_id);
			// if (['newjigu'].includes(this.company_id)) combineInvAndPDC(data.data);

			const reportTemplate = await apiGetBase64ReportTemplate('customerStatement', companyMrtUrl('customerStatement'));
			let ccList = [];
			if (data.data.length === 1) {
				if (data.data[0].customer.email) ccList.push(data.data[0].customer.email);
			}
			const report = new Report(reportTemplate, data, 'CustomerStatement', PrintType.Normal, false, false, ccList);
			this.$store.commit('setReport', report);
		},
		customersWithNoRecentSalesShow() {
			this.$store.dispatch('partners/AC_CustomersWithNoRecentSalesModalShow', true);
		},
	},
	created() {
		let route = this.$route;
		if (route.query.initial_partner_type) {
			this.initial_partner_type = route.query.initial_partner_type;
		} else {
			this.initial_partner_type = route.meta.initial_partner_type;
		}

		this.$store.commit('setSideIndex', 8);

		if (this.initial_partner_type === 'C') {
			this.$store.commit('setSelectedMenu', 'nav_li_customer_main');
			this.$store.commit('setSubTitle', 'Partner -> Customer');
		} else if (this.initial_partner_type === 'V') {
			this.$store.commit('setSelectedMenu', 'nav_li_vendor_main');
			this.$store.commit('setSubTitle', 'Partner -> Vendor');
		} else {
			this.$store.commit('setSelectedMenu', 'nav_li_partner_main');
			this.$store.commit('setSubTitle', 'Partner -> Main');
		}

		this.partner_type = this.initial_partner_type;

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		// makeTableResizable();
	},
};
</script>

<style>
.batch_partners_row .left_option {
	display: flex;
	align-items: center;
}
.batch_partners_row .int_type_no_border {
	flex: 1 1 0;
	min-width: 0;
}
</style>
